import { z } from 'zod';

// ── Request (PUT) ─────────────────────────────────────────────────────────────
//
// Full replace — no partial updates. Zod enforces compAuthorizedRoles values.
// If compsEnabled=false and compAuthorizedRoles is non-empty, the UC rejects (domain invariant).

export const UpdateCompConfigRequestSchema = z.object({
  compsEnabled: z.boolean(),
  compAuthorizedRoles: z.array(z.enum(['supervisor', 'operator'])),
});

export type UpdateCompConfigRequest = z.infer<typeof UpdateCompConfigRequestSchema>;

// ── Response (GET / PUT) ─────────────────────────────────────────────────────
//
// updatedAt is null when no config row has been persisted yet (defaults).

export const CompConfigResponseSchema = z.object({
  compsEnabled: z.boolean(),
  compAuthorizedRoles: z.array(z.string()),
  updatedAt: z.string().nullable(),
});

export type CompConfigResponse = z.infer<typeof CompConfigResponseSchema>;
